import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Gamepad2, X } from "lucide-react";

const STORAGE_KEY = "secqre.fab.dismissed";

export default function GameFab() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(true);
  const [bestScore, setBestScore] = useState(null);

  useEffect(() => {
    try {
      const dismissed = sessionStorage.getItem(STORAGE_KEY);
      if (dismissed === "1") setOpen(false);
      const best = localStorage.getItem("secqre.honk.best");
      if (best) setBestScore(parseInt(best, 10));
    } catch (_) {}
  }, []);

  // Hide on game page itself
  if (pathname === "/play") return null;
  if (!open) return null;

  return (
    <div className="fixed bottom-5 right-5 z-40 max-w-[300px]" data-testid="game-fab">
      <div className="relative rounded-2xl border border-[#0A0A0A] bg-[#FFD600] p-4 shadow-[0_20px_40px_-10px_rgba(15,23,42,0.35)] animate-fade-up">
        <button
          onClick={() => {
            setOpen(false);
            try { sessionStorage.setItem(STORAGE_KEY, "1"); } catch (_) {}
          }}
          aria-label="Dismiss"
          className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-[#0A0A0A] text-white inline-flex items-center justify-center hover:scale-110 transition-transform"
          data-testid="game-fab-close"
        >
          <X className="w-3.5 h-3.5" />
        </button>

        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-[#0A0A0A] text-[#FFD600] inline-flex items-center justify-center shrink-0">
            <Gamepad2 className="w-5 h-5" />
          </div>
          <div>
            <div className="font-heading font-bold text-base text-[#0A0A0A] leading-snug">Wrongly parked? Honk it.</div>
            <p className="mt-1 text-xs text-[#0A0A0A]/80 leading-snug">
              Play <strong>Honk Patrol</strong> — a 60-second arcade game.
              {bestScore != null && <> Your best: <strong>{bestScore}</strong></>}
            </p>
            <Link
              to="/play"
              className="mt-3 inline-flex items-center gap-1.5 rounded-md bg-[#0A0A0A] text-white px-3 py-1.5 text-xs font-semibold hover:bg-[#1E293B] transition-colors"
              data-testid="game-fab-play"
            >
              Play now →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
